import styled from 'styled-components'

import { Color } from 'root-constants'

import { FemiFlowColor } from '../../constants'

const BUTTON_COLORS = {
  primary: { background: Color.BLACK, text: Color.WHITE },
  secondary: { background: FemiFlowColor.GRAY_LIGHT, text: Color.BLUE_DARK },
  transparent: { background: 'transparent', text: Color.BLUE_DARK },
}

type TProps = {
  variant?: keyof typeof BUTTON_COLORS
}

export const FlowButton = styled.button.attrs<TProps>(
  ({ variant = 'primary' }) => ({ 'data-variant': variant }),
)<TProps>`
  width: 100%;
  height: 56px;
  padding: 0 16px;
  border: none;
  border-radius: 16px;
  outline: none;
  cursor: pointer;
  background-color: ${({ variant = 'primary' }) =>
    BUTTON_COLORS[variant].background};
  color: ${({ variant = 'primary' }) => BUTTON_COLORS[variant].text};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;

  &:disabled {
    cursor: default;
    background-color: ${FemiFlowColor.GRAY_DISABLED};
  }
`
